import React from "react";
import { Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import TrustBand from "./components/landing/TrustBand";
import ProductShowcase from "./components/landing/ProductShowcase";
import Features from "./components/Features";
import Ecosystem from "./components/landing/Ecosystem";
import Cashless from "./components/landing/Cashless";
import Parents from "./components/landing/Parents";
import About from "./components/About";
import VideoTestimonials from "./components/VideoTestimonials";
import Testimonials from "./components/Testimonials";
import Onboarding from "./components/landing/Onboarding";
import Pricing from "./components/Pricing";
import DemoRequestForm from "./components/DemoRequestForm";
import FinalCta from "./components/landing/FinalCta";
import Footer from "./components/Footer";
import "./App.css";
import "./styles/landing.css";
import { DownloadRequest } from "./components/Download";
import SchoolProfileRoute from "./components/schoolProfile/SchoolProfileRoute";
import SchoolProfileNotFound from "./components/schoolProfile/SchoolProfileNotFound";
import SchoolAdmissionRoute from "./components/schoolProfile/admission/SchoolAdmissionRoute";

/*
  Landing page section order. Each section owns one job and one layout, and the
  anchor ids (about, features, pricing, testimonials, video-testimonials,
  demo-form) are the ones the previous site used, so existing links still land
  in the right place.
*/
const LandingPage = () => (
  <div className="ab-page">
    <a className="ab-skip-link" href="#main">
      Skip to content
    </a>
    <Header />
    <main id="main">
      <Hero />
      <TrustBand />
      <ProductShowcase />
      <Features />
      <Ecosystem />
      <Cashless />
      <Parents />
      <About />
      <VideoTestimonials />
      <Testimonials />
      <Onboarding />
      <Pricing />
      <DemoRequestForm />
      <FinalCta />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/download" element={<DownloadRequest />} />

        {/*
          Any other root-level path is treated as a school public path
          (e.g. /queens-school). Reserved website paths are filtered out inside
          SchoolProfileRoute.
        */}
        <Route path="/:publicPath" element={<SchoolProfileRoute />} />

        {/* Public admission application for that same school. */}
        <Route path="/:publicPath/admission" element={<SchoolAdmissionRoute />} />

        <Route path="*" element={<SchoolProfileNotFound variant="page" />} />
      </Routes>
    </>
  );
}

export default App;
